export default __webpack_public_path__ + "media/images/home/corporate/lg-84edf42bbdd5895ca07ea327ffcf63ac.jpg";